/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { relativePrioritySchema } from './relativePrioritySchema';
import { upsertEstimationRequestSchema } from './upsertEstimationRequestSchema';

export const patchEstimationSchemeRequestSchema = z.object({
  description: z.string().nullish(),
  get estimations() {
    return z.array(upsertEstimationRequestSchema).nullish();
  },
  isOrganizationDefault: z.boolean().nullish(),
  name: z.string().nullish(),
  get relativePriority() {
    return relativePrioritySchema.nullish();
  },
});
